import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { CadastrosComponent } from './pages/cadastros/cadastros.component';
import { ActivationComponent } from './pages/activation/activation.component';
import { FeedComponent } from './pages/feed/feed.component';
import { IntranetDashComponent } from './pages/intranet-dash/intranet-dash.component';
import { PostEditorComponent } from './pages/post-editor/post-editor.component';
import { ControlsignComponent } from './pages/controlsign/controlsign.component';
import { ControltaskComponent } from './pages/controltask/controltask.component';
import { ControlMentorComponent } from './pages/controlmentor/controlmentor.component';
import { ControlDocsComponent } from './pages/controldocs/controldocs.component';
import { ControldocsShareComponent } from './pages/controldocs-share/controldocs-share.component';
import { ControlcliComponent } from './pages/controlcli/controlcli.component';
import { ControlhelpComponent } from './pages/controlhelp/controlhelp.component';
import { ControlprojectComponent } from './pages/controlproject/controlproject.component';
import { ControlflowComponent } from './pages/controlflow/controlflow.component';
import { ControlflowEditorComponent } from './pages/controlflow-editor/controlflow-editor.component';
import { ControlsafeComponent } from './pages/controlsafe/controlsafe.component';
import { ControlquestionComponent } from './pages/controlquestion/controlquestion.component';
import { ControlquestionPublicComponent } from './pages/controlquestion-public/controlquestion-public.component';
import { ControlquestionIntranetComponent } from './pages/controlquestion-intranet/controlquestion-intranet.component';
import { ControlaiComponent } from './pages/controlai/controlai.component';
import { ControldpComponent } from './pages/controldp/controldp.component';
import { DigitalAdmissionComponent } from './pages/digital-admission/digital-admission.component';
import { ControlopComponent } from './pages/controlop/controlop.component';
import { ControlbordoComponent } from './pages/controlbordo/controlbordo.component';
import { DesktopDownloadComponent } from './pages/desktop-download/desktop-download.component';
import { ControlchatDesktopComponent } from './pages/controlchat-desktop/controlchat-desktop.component';
import { ControlsocialComponent } from './pages/controlsocial/controlsocial.component';
import { ControlmonitorComponent } from './pages/controlmonitor/controlmonitor.component';
import { MystoreComponent } from './pages/mystore/mystore.component';
import { ControlDossieComponent } from './pages/controldossie/controldossie.component';
import { ControlinventoryComponent } from './pages/controlinventory/controlinventory.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'home', redirectTo: 'feed', pathMatch: 'full' },
  { path: 'cadastros', component: CadastrosComponent, canActivate: [AuthGuard] },
  { path: 'feed', component: FeedComponent, canActivate: [AuthGuard] },
  { path: 'intranet-dash', component: IntranetDashComponent, canActivate: [AuthGuard] },
  { path: 'intranet-post', component: PostEditorComponent, canActivate: [AuthGuard] },
  { path: 'controlsign', component: ControlsignComponent, canActivate: [AuthGuard] },
  { path: 'controltask', component: ControltaskComponent, canActivate: [AuthGuard] },
  { path: 'controlproject', component: ControlprojectComponent, canActivate: [AuthGuard] },
  { path: 'controlmentor', component: ControlMentorComponent, canActivate: [AuthGuard] },
  { path: 'controldocs', component: ControlDocsComponent, canActivate: [AuthGuard] },
  { path: 'controlcli', component: ControlcliComponent, canActivate: [AuthGuard] },
  { path: 'controlhelp', component: ControlhelpComponent, canActivate: [AuthGuard] },
  { path: 'controlsafe', component: ControlsafeComponent, canActivate: [AuthGuard] },
  { path: 'controlquestion', component: ControlquestionComponent, canActivate: [AuthGuard] },
  { path: 'controlai', component: ControlaiComponent, canActivate: [AuthGuard] },
  { path: 'controldp', component: ControldpComponent, canActivate: [AuthGuard] },
  { path: 'digital-admission', component: DigitalAdmissionComponent },
  { path: 'controlop', component: ControlopComponent, canActivate: [AuthGuard] },
  { path: 'controlbordo', component: ControlbordoComponent, canActivate: [AuthGuard] },
  { path: 'controlsocial', component: ControlsocialComponent, canActivate: [AuthGuard] },
  { path: 'controlmonitor', component: ControlmonitorComponent, canActivate: [AuthGuard] },
  { path: 'controlinventory', component: ControlinventoryComponent, canActivate: [AuthGuard] },
  { path: 'mystore', component: MystoreComponent, canActivate: [AuthGuard] },
  { path: 'controldossie', component: ControlDossieComponent, canActivate: [AuthGuard] },
  { path: 'download-desktop', component: DesktopDownloadComponent, canActivate: [AuthGuard] },
  { path: 'controlchat-desktop', component: ControlchatDesktopComponent, canActivate: [AuthGuard] },
  { path: 'controlquestion-intranet', component: ControlquestionIntranetComponent, canActivate: [AuthGuard] },
  { path: 'controlquestion-intranet/respond', component: ControlquestionPublicComponent, canActivate: [AuthGuard] },
  { path: 'controlquestion/public/:token', component: ControlquestionPublicComponent },
  { path: 'controlflow', component: ControlflowComponent, canActivate: [AuthGuard] },
  { path: 'controlflow/novo', component: ControlflowEditorComponent, canActivate: [AuthGuard] },
  { path: 'controlflow/:id', component: ControlflowEditorComponent, canActivate: [AuthGuard] },
  { path: 'docs/share/:token', component: ControldocsShareComponent },
  { path: 'ativacao', component: ActivationComponent },

  // Redireciona raiz para feed
  { path: '', redirectTo: 'feed', pathMatch: 'full' },

  // Rota caso digite algo inexistente
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
